import React, { useRef, useState , useEffect} from "react";
import Chatroom from "../chatroom";
import Chatfooter from "../chatfooter";
import ChatBotHeader from "./Header";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";
import "./chatbot.css";
import { db } from "../../config/firebase";
import { getCookie, setCookie } from "../../utils/local_storing";


function ChatBot(props) {
  const [newMessages, setNewMessage] = useState([]);
  const [startNewChat, setStartNewChat] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const chatRoomRef = useRef(null);
  const [showExtraContent, setShowExtraContent] = useState(true);
  const [localdata, setlocaldata] = useState("");
const refreshHandlerRef = useRef(null);
  // Function to toggle the extra content visibility
  const toggleExtraContent = () => {
    setShowExtraContent(prev => !prev);
  };
  const handleRefreshFromHeader = () => {
    // Call the refresh handler from Chatroom if it exists
    if (refreshHandlerRef.current) {
      refreshHandlerRef.current();
    }
  };
  const setRefreshHandler = (handler) => {
    refreshHandlerRef.current = handler;
  };



  function getCurrentISTDate() {
    const date = new Date();

    // Convert the current date to IST by adding the IST offset
    const utcOffset = date.getTimezoneOffset(); // Offset in minutes
    const istOffset = 330; // IST offset in minutes (UTC+5:30)
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);

    // Get the year, month, and day
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  // Save action to Firestore (similar to ChatFooter handlechange)
  const saveActionToFirestore = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const channel = urlParams.get("channel") || "Web";
      const shopId = currentDomain || "null";
      const exactUrl = urlParams.get("currentUrl");
      if (exactUrl && exactUrl.includes("/products/")) {
    
      // Extract the product name from the URL after /products/ and before & or ? if exists
      let productName = exactUrl.split("/products/")[1].split(/[&?]/)[0];
       productName=productName.replace(/-/g, ' ');
      setlocaldata(`Hello, I can tell you all about ${productName}? Let me know if you want to know more about it.`);
    
    } else {
      setlocaldata("Hello, how can I help you?");
    }
      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";

      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
        const docRef = doc(db, "Messages", docid);
        const docSnap = await getDoc(docRef);
        let assigned_to = "bot@krunk.ai";

        if (!docSnap.exists()) {
          await setDoc(docRef, {
            Chat_Status: "Open",
            Fetch_Firestore: true,
            Messages: [{ server: localdata, server_timestamp: date_string }],
            server: false,
            user_id: uid,
            shop_id: shopId,
            User_Channel: "Web",
            timestamp: Date.now(),
            ticket_id: docid,
            assigned_to: "bot@krunk.ai",
            doc_id: docid,
            User_Timestamp: getCurrentISTDate(),
            created_at: serverTimestamp(),
            last_updated: serverTimestamp(),
          }, { merge: true });
        }
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }
    } catch (error) {
      console.error("Error saving action to Firestore:", error);
    }
  };

  // Call saveActionToFirestore when component mounts
  useEffect(() => {
    saveActionToFirestore();
  }, []); // Empty dependency array means this runs once when component mounts

return (
  <div className="krunk-h-full krunk-flex krunk-items-center krunk-justify-center krunk-px-[3px] krunk-pt-[0px] krunk-pb-[60px] md:krunk-p-0">
    <div   
      style={{ boxShadow: "3px 3px 5px 0 rgba(0, 0, 0, 0.3)" }}
      className="krunk-border krunk-border-gray-100 krunk-bg-white krunk-bg-headercolor 
                 krunk-h-full krunk-w-full 
                 md:krunk-w-[390px] md:krunk-max-h-[580px] md:krunk-rounded-xl 
                 krunk-rounded-lg
                 krunk-flex krunk-flex-col"
    >
      <div className="krunk-h-full krunk-font-[Poppins] krunk-text-[#333333] krunk-flex krunk-flex-col krunk-rounded-lg md:krunk-rounded-xl krunk-overflow-hidden">
        <ChatBotHeader 
          title={props.title} 
          imageurl={props.imageurl} 
          showExtraContent={showExtraContent}
          setfloat_Visible={props.setfloat_Visible}
          float_visible={props.float_visible}
          onRefresh={handleRefreshFromHeader}
        />
        <main
          ref={chatRoomRef}
          className="krunk-px-4 krunk-flex-1 krunk-border-2 krunk-border-gray-50 krunk-overflow-y-auto krunk-scrollbar-none"
        >
          <div className="krunk-flex krunk-flex-col krunk-h-full">
            <Chatroom 
              sharedData={newMessages} 
              userId={props.userId} 
              isLoading={isLoading}  
              setIsLoading={setIsLoading}
              actionButtons={props.actionButtons}
              onRefreshHandler={setRefreshHandler}
              subMenu={props.subMenu}
            />
          </div>
        </main>
   
        <footer className="krunk-text-primary krunk-rounded-b-lg md:krunk-rounded-b-3xl">
          <Chatfooter
            messageupdate={setNewMessage}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setStartNewChat={setStartNewChat}
            startNewChat={startNewChat}
          />
        </footer>
      </div>
    </div>
  </div>
);


}



export default ChatBot;


